import * as React from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  Stack,
  Grid,
  CardActionArea,
  Card,
  Skeleton,
  Button,
  Tooltip,
} from "@mui/material";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import StorageIcon from "@mui/icons-material/Storage";
import { ChallengeCardType } from "../../lib/challengeAPI";
import { Link } from "react-router-dom";
import styles from "../../styles/challenge/challengeCard.module.css";
import { toShortNumber } from "../../lib/util";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import LinkIcon from "@mui/icons-material/Link";

export const ChallengeCard: React.FC<ChallengeCardType> = (props) => {
  const {
    fund_name,
    challenge_name,
    description,
    quick_stats_data,
    fund_id,
    challenge_id,
    challenge_amount,
    challenge_url,
    includes_proposals_sponsored_by_leftovers,
  } = props;

  return (
    <Card elevation={4} className={styles.cardPaper}>
      <CardActionArea component={Link} to={"/fund/" + fund_id + "/challenges"}>
        <CardContent>
          <Typography color="textPrimary">{fund_name}</Typography>
        </CardContent>
      </CardActionArea>

      <CardContent sx={{ marginTop: "-20px" }}>
        <Stack>
          <CardActionArea
            component={Link}
            to={"/challenge/" + challenge_id}
            state={{ challenge_stats: quick_stats_data }}
          >
            {/* <Tooltip title={challenge_name}> */}
            <Typography variant="h6" className={styles.challengeName}>
              {challenge_name}
            </Typography>
            {/* </Tooltip> */}
          </CardActionArea>
          <Box className={styles.challengeDescBox}>
            <Typography className={styles.paragraph}>{description}</Typography>
          </Box>
        </Stack>

        <Stack direction="row" className={styles.challengeStack}>
          <Grid container direction="column" alignItems="center">
            <CurrencyExchangeIcon />
            <Typography color="textPrimary" variant="body2">
              {includes_proposals_sponsored_by_leftovers ? (
                <Tooltip title="Some proposals in this challenge were sponsored through leftover funds">
                  <span>
                    ${toShortNumber(challenge_amount)}
                    <sup style={{ fontSize: "15px", marginTop: "-15px" }}>
                      *
                    </sup>
                  </span>
                </Tooltip>
              ) : (
                <>${toShortNumber(challenge_amount)}</>
              )}
            </Typography>
            <Typography variant="caption">Budget</Typography>
          </Grid>

          <Grid container direction="column" alignItems="center">
            <RequestPageOutlinedIcon />
            <Typography color="textPrimary" variant="body2">
              ${toShortNumber(quick_stats_data.amount_requested)}
            </Typography>
            <Typography variant="caption" color="textPrimary">
              Requested
            </Typography>
          </Grid>

          <Grid container direction="column" alignItems="center">
            <DocumentScannerIcon />
            <Typography color="textPrimary" variant="body2">
              {quick_stats_data.total_proposals}
            </Typography>
            <Typography variant="caption">Proposals</Typography>
          </Grid>

          <Grid container direction="column" alignItems="center">
            <StorageIcon />
            <Typography color="textPrimary" variant="body2">
              {quick_stats_data.funded_proposals}
            </Typography>
            <Typography variant="caption">Projects</Typography>
          </Grid>
        </Stack>

        <Button
          target="_blank"
          href={challenge_url}
          startIcon={<LinkIcon />}
          sx={{ pt: 2 }}
        >
          View Challenge on ideascale
        </Button>
      </CardContent>
    </Card>
  );
};

export const ChallengeCardLoading = () => {
  return (
    <Card className={styles.cardPaper} elevation={4}>
      <Skeleton variant="rectangular" className={styles.skeletonCardHead} />

      <CardContent>
        <Skeleton variant="rectangular" className={styles.skeletonChallName} />
        <Skeleton variant="rectangular" className={styles.fullWidthGrid} />
        <Skeleton variant="rectangular" className={styles.skeletonChallDesc} />
        <Grid container className={styles.skeletonGrid}>
          <Skeleton
            variant="rectangular"
            className={styles.skeletonChallIcon}
          />
          <Skeleton
            variant="rectangular"
            className={styles.skeletonChallIcon}
          />
          <Skeleton
            variant="rectangular"
            className={styles.skeletonChallIcon}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};
